module.exports = __webpack_public_path__ + "media/images/flags/16/Venezuela-03b76e1b5a5d423ba3f54fb3d692b597.png";